module.exports = __webpack_public_path__ + "media/applicants/grocerybundle-0ab91db0.jpg";